import {
  MAX_TOKEN_REFRESH,
  REFRESH_TOKEN_ACTION,
  RESPONSE_TYPE
} from "../redux/constants/metaData";

export const getPayloadValue = (payload, defaultValue) => {
  return payload === null
    ? defaultValue
    : payload === undefined
      ? defaultValue
      : payload === ""
        ? defaultValue
        : payload;
};

export const isValidPlayload = (payload) => {
  return payload === null
    ? false
    : payload === undefined
      ? false
      : payload === ""
        ? false
        : true;
};

export const isTokenRefreshRequired = (
  errorResponse,
  tokenRefreshPreAction,
  refreshTokenAction,
) => {
  if (errorResponse && errorResponse.status === 401) {
    if (
      isValidPlayload(tokenRefreshPreAction) &&
      tokenRefreshPreAction.retry < MAX_TOKEN_REFRESH &&
      tokenRefreshPreAction.actionType === refreshTokenAction
    ) {
      return true;
    }
  }

  return false;
};

export const getUpdatedTokenRefreshPreAction = (
  tokenRefreshPreAction,
  refreshTokenAction,
) => {
  let noOfRetry =
    isValidPlayload(tokenRefreshPreAction) === true
      ? tokenRefreshPreAction.retry + 1
      : 1;
  return {
    retry: noOfRetry,
    actionType: refreshTokenAction,
  };
};

export const isTokenRefreshFailed = (tokenRefreshPreAction) => {
  return (
    isValidPlayload(tokenRefreshPreAction) &&
    tokenRefreshPreAction.refreshResponse === RESPONSE_TYPE.failure
  );
}
